export var slice = Array.prototype.slice;



//////////////////
// WEBPACK FOOTER
// ./~/d3/~/d3-axis/src/array.js
// module id = 226
// module chunks = 0 1 2 3 4